import { MobileTokenPickerSheet } from '@/widgets/swap/nutrimatic/mobile/MobileTokenPickerSheet'
import type { ChainId, Currency } from '@/sdk'

import { MobileNutrimaticTokenPicker } from './MobileNutrimaticTokenPicker'

/** Sheet del picker Nutrimatic para flujos de liquidez (añadir / importar / retirar). */
export function LiquidityMobileTokenPickerSheet({
  open,
  onClose,
  chainId,
  title,
  excludeCurrency,
  onSelect,
  placement = 'fullscreen',
}: {
  open: boolean
  onClose: () => void
  chainId: ChainId
  title: string
  excludeCurrency?: Currency | null
  onSelect: (currency: Currency) => void
  /** `embedded`: solo cubre el panel trade en tableta desktop. */
  placement?: 'fullscreen' | 'embedded'
}) {
  return (
    <MobileTokenPickerSheet open={open} onClose={onClose} placement={placement}>
      <MobileNutrimaticTokenPicker
        chainId={chainId}
        mode="list"
        title={title}
        excludeCurrency={excludeCurrency}
        onSelect={onSelect}
        onBack={onClose}
      />
    </MobileTokenPickerSheet>
  )
}
